import React, { useState, useEffect, useRef  } from 'react';
import { getimagesDriveIT, uploadimagesDriveIT, getDriveit,  driveitupdate, driveitarchiveid } from '../../api/api';
import { faTrash  } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation, useNavigate } from 'react-router-dom';
import Webcam from 'react-webcam';
import Modal from 'react-modal';
import '../../styles/Buttons.css';
import '../../styles/Texts.css';
import '../../styles/Alinhamento.css';
import '../../styles/Imagens.css';
import "react-widgets/styles.css";

const BOOLEAN_FIELDS = [
    { key: 'GERAR_ETIQUETA', label: 'GERAR ETIQUETA' },
    { key: 'TRAVA_SEGURANCA', label: 'TRAVA DE SEGURANÇA' },
    { key: 'FORA_DA_BASE', label: 'FORA DA BASE' },
];
const PHOTO_LABELS = ['Evidência', 'Etiqueta', 'Trava de segurança'];
const toBoolean = value => value === true || value === 1 || value === '1' || value === 'true';

function EditarDriveIT() {
    const genericImg = 'data:image/jpeg;base64,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'

    const location = useLocation();
    const { user, equipamentos, rooms, modelos } = location.state || {};
    const roomSuggestions = rooms || []
    const modelosSuggestions = modelos || []
    const navigate = useNavigate();        
    const [equipamento, setEquipamento] = useState({});
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [showImageOptions, setShowImageOptions] = useState(false);
    const [isCameraModalOpen, setIsCameraModalOpen] = useState(false);
    const [isWebcamModalOpen, setIsWebcamModalOpen] = useState(false);
    const [selectedCamera, setSelectedCamera] = useState();
    const [imageUrls, setImageUrls] = useState([]);
    const [loading, setLoading] = useState(true);
    const webcamRef = useRef(null);

    useEffect(() => {
        if (equipamentos === undefined) {
            navigate('/');
        } else {
            setEquipamento({
                SERIAL: equipamentos.numero_serie || '',
                HOSTNAME: equipamentos.nome || '',                               
                ROOM: equipamentos.room || '',                
                FLOOR: equipamentos.floor || '',
                MODELO: equipamentos.id_modelo || '',
                STATUS: equipamentos.encontrado || '',
                GERAR_ETIQUETA: toBoolean(equipamentos.verificacao_etiqueta),
                TRAVA_SEGURANCA: toBoolean(equipamentos.trava_seguranca),
                DATA: equipamentos.alterado_em || '',
                ANALISTA: equipamentos.analista || user, 
                OBSERVAÇÃO: equipamentos.comentarios || '',
                FORA_DA_BASE: toBoolean(equipamentos.fora_da_base),                 
                
                
            });
            fetchImages(equipamentos.pk);
        }
    }, [equipamentos, navigate]);
    const videoConstraints = {facingMode: { exact: "environment" }};
    
    const fetchImages = async (index) => {
        try {
            const response = await getimagesDriveIT(index);            
            setImageUrls(response.images || []);
        } catch (error) {
            console.error('Error fetching images:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setEquipamento(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const fetchUsers = async (updatedEquipamento) => {
        const campoMapeado = {
            SERIAL: 'numero_serie',HOSTNAME: 'nome',ROOM: 'room',FLOOR: 'floor',MODELO: 'id_modelo',
            STATUS: 'encontrado',GERAR_ETIQUETA: 'verificacao_etiqueta', TRAVA_SEGURANCA: 'trava_seguranca', DATA: 'alterado_em',
            OBSERVAÇÃO: 'comentarios', FORA_DA_BASE: 'fora_da_base'
        };

        const originalPayload = {};
        for (const [visivel, original] of Object.entries(campoMapeado)) {
            originalPayload[original] = updatedEquipamento[visivel];
        }
        
        const equipamentosLocal = JSON.parse(localStorage.getItem('equipamentos')) || [];
        // Ignora o equipamento atual no filtro (caso seja edição)
        const duplicado = equipamentosLocal.find((equip) =>
            equip.pk !== equipamentos.pk &&
            (equip.nome === originalPayload.nome || equip.numero_serie === originalPayload.numero_serie)
        );
        if (duplicado) {
            alert('Já existe um equipamento com o mesmo hostname ou número de série.');
            return;
        }        

        try {
            const response = await driveitupdate(user, equipamentos.pk, originalPayload);

            if (!navigator.onLine) {
                alert('Você está offline. O equipamento foi salvo localmente e será sincronizado depois.');

                const equipamentosLocal = JSON.parse(localStorage.getItem('equipamentos')) || [];

                const equipamentosAtualizados = equipamentosLocal.map((equip) =>
                    equip.pk === equipamentos.pk
                        ? { ...equip, ...originalPayload }
                        : equip
                );
                localStorage.setItem('equipamentos', JSON.stringify(equipamentosAtualizados));
                navigate('/driveit', { state: { user } })
                return;
            }            

            if (navigator.onLine) {
                const response = await getDriveit();
                const equipamento = response.map((r) => ({
                    ...r.fields,
                    pk: r.pk
                }));
                localStorage.setItem('equipamentos', JSON.stringify(equipamento));
                alert('Equipamento atualizado com sucesso.');
                navigate('/driveit', { state: { user } })
            }
        } catch (error) {
            alert(`Ocorreu um erro ao atualizar o equipamento. Por favor, entre em contato com o administrador do sistema. Erro: ${error.message}`);
        }
    };

    
    const handleSave = async () => {
        await fetchUsers(equipamento);
                

    };

    const handleOpenCameraModal = (slot) => {
        setSelectedSlot(slot);
        setShowImageOptions(true);
        setIsCameraModalOpen(true);
    };

    const handleOpenWebcamModal = (cameraIndex) => {               
        setSelectedCamera(cameraIndex);        
        setIsCameraModalOpen(false);
        setIsWebcamModalOpen(true);
    };

    const handleTakePhoto = async (slot) => {
        const imageSrc = webcamRef.current?.getScreenshot();
        if (!imageSrc) {
            alert('Aguarde a câmera ficar pronta antes de salvar a foto.');
            return;
        }
        setIsWebcamModalOpen(false);       
        let filename = `${equipamentos.nome}_Imagem.jpg`;
        if (slot === 0) {
            filename = `${equipamentos.nome}_Evidencia.jpg`;
        } else if (slot === 1) {
            filename = `${equipamentos.nome}_Etiqueta.jpg`;
        } else if (slot === 2) {
            filename = `${equipamentos.nome}_Trava.jpg`;
        }    
        
        await uploadimagesDriveIT(equipamentos.pk,imageSrc, slot, filename );
        await fetchImages(equipamentos.pk)
        setIsCameraModalOpen(true);             
    };

    const handleDeletePhoto = async (slot) => {
        setIsWebcamModalOpen(false);
        const imageSrc = genericImg;       
        let filename = `Deleted_Imagem.jpg`;        
        await uploadimagesDriveIT(equipamentos.pk,imageSrc, slot, filename );
        await fetchImages(equipamentos.pk)
        setIsCameraModalOpen(true);             
    };

    const handleTakePhotoCancel = () => {
        setIsWebcamModalOpen(false); 
        setIsCameraModalOpen(true) 
    };

    const handleOpenWebcamModalCancel = () => {              
        setIsCameraModalOpen(false);
        setIsWebcamModalOpen(false);
    };

    const archive = async () => {        
        const archive = await driveitarchiveid(equipamentos.pk);
        const response = await getDriveit();
        const equipamento = response.map((r) => ({
            ...r.fields,
            pk: r.pk
        }));        
        localStorage.setItem('equipamentos', JSON.stringify(equipamento));
        setLoading(false);        
        
    };


    const fileInputRef = useRef(null);

    const handleUploadFromPC = () => {
        fileInputRef.current.click();
    };

    const handleFileSelect = async (event) => {
        const file = event.target.files[0];
        console.log("Arquivo selecionado:", file);

        if (file && file.type.startsWith('image/')) {
            const reader = new FileReader();

            reader.onloadend = async () => {
                const imageSrc = reader.result;

                let filename = `${equipamentos.nome}_Imagem.jpg`;
                if (selectedSlot === 0) {
                    filename = `${equipamentos.nome}_Evidencia.jpg`;
                } else if (selectedSlot === 1) {
                    filename = `${equipamentos.nome}_Etiqueta.jpg`;
                } else if (selectedSlot === 2) {
                    filename = `${equipamentos.nome}_Trava.jpg`;
                }
                
                await uploadimagesDriveIT(equipamentos.pk, imageSrc, selectedSlot, filename);
                await fetchImages(equipamentos.pk);
            };

            reader.readAsDataURL(file);
        } else {
            alert('Por favor, selecione uma imagem válida.');
        }
    };

    // Use slot IDs, never the order returned by the API (0, 1 and 2).
    const photoSlots = PHOTO_LABELS.map((label, slot) => ({
        slot,
        label,
        image: imageUrls.find(img => Number(img.slot) === slot)?.image || genericImg
    }));

    return (
        <>          

            <main className="driveit-edit-page">
                <style>{`
                    .driveit-edit-page .driveit-boolean-fields {
                        display: grid;
                        grid-template-columns: minmax(0, 1fr);
                        gap: 12px;
                        width: 100%;
                        max-width: 100%;
                        min-width: 0;
                        margin: 12px 0 0;
                        padding: 0;
                        box-sizing: border-box;
                        flex: 0 0 auto;
                        grid-column: 1 / -1;
                        align-self: flex-start;
                    }
                    .driveit-edit-page .driveit-boolean-row {
                        display: grid;
                        grid-template-columns: minmax(0, 1fr) 18px;
                        align-items: center;
                        gap: 12px;
                        width: 100%;
                        margin: 0;
                        padding: 0;
                        text-align: left;
                        cursor: pointer;
                        box-sizing: border-box;
                    }
                    .driveit-edit-page .driveit-boolean-row span {
                        margin: 0;
                        padding: 0;
                        text-align: left;
                        line-height: 1.4;
                    }
                    .driveit-edit-page .driveit-boolean-row input[type="checkbox"] {
                        appearance: auto;
                        position: static;
                        display: block;
                        width: 18px;
                        min-width: 18px;
                        max-width: 18px;
                        height: 18px;
                        min-height: 18px;
                        margin: 0;
                        padding: 0;
                        transform: none;
                        justify-self: end;
                        align-self: center;
                        cursor: pointer;
                    }
                `}</style>
                <p className="texto-principal-da-pagina">Editar Entrada</p>
                <div className='icon-container'>
                    
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                    <FontAwesomeIcon 
                        icon={faTrash}
                        title="Arquivar equipamento"
                        style={{  fontSize: '32px', cursor: 'pointer' }} 
                        onClick={archive}
                    />                                        
                </div>

                </div>


                <div className='conteudo-principal'>
                    <div className='equipamento-barra-alinhamento'>
                        <div className='equipamento-conteudo'>
                            {Object.entries(equipamento).filter(([key]) => !BOOLEAN_FIELDS.some(field => field.key === key)).map(([key, value]) => {
                                let inputElement;
                                if (key === 'STATUS') {
                                    inputElement = (
                                        <select name={key} value={value} onChange={handleInputChange}>
                                            <option value="DESAPARECIDO">DESAPARECIDO</option>
                                            <option value="ENCONTRADO">ENCONTRADO</option>
                                            <option value="NÃO ENCONTRADO">NÃO ENCONTRADO</option>
                                        </select>
                                    );
                                } else if (key === 'DATA') {
                                    const formattedValue = value ? new Date(new Date(value).getTime() - 6 * 60 * 60 * 1000).toISOString().slice(0, 16): '';
                                    inputElement = (<input type='datetime-local' name={key} value={formattedValue} disabled />                                    );
                                } else if (key === 'vencimento_garantia') {
                                    const formattedValue = value ? new Date(value).toISOString().slice(0, 16) : '';
                                    inputElement = (<input type='datetime-local' name={key} value={formattedValue} onChange={handleInputChange} />);
                                } else if (key === 'primeira_descoberta_em') {
                                    console.log(value)
                                    const formattedValue = value ? new Date(value).toISOString().slice(0, 16) : '';
                                    console.log(formattedValue)
                                    inputElement = (<input type='datetime-local' name={key} value={formattedValue} onChange={handleInputChange} />);
                                }else if (key === 'ROOM') {
                                    inputElement = (
                                        <>
                                        <input
                                            type='text'
                                            name={key}
                                            value={value}
                                            onChange={handleInputChange}
                                            list="room-options"
                                        />
                                        <datalist id="room-options">
                                            {roomSuggestions.map((room, index) => (
                                            <option key={index} value={room} />
                                            ))}
                                        </datalist>
                                        </>
                                    );
                                }else if (key === 'MODELO') {
                                    inputElement = (
                                        <>
                                        <input
                                            type='text'
                                            name={key}
                                            value={value}
                                            onChange={handleInputChange}
                                            list="model-options"
                                        />
                                        <datalist id="model-options">
                                            {modelosSuggestions.map((id_modelo, index) => (
                                            <option key={index} value={id_modelo} />
                                            ))}
                                        </datalist>
                                        </>
                                    );                                                                          
                                } else {
                                    inputElement = (<input type='text' name={key} value={value} onChange={handleInputChange} />);
                                }

                                return (
                                    <div className='equipamento-item' key={key}>
                                        <label>{key.replaceAll('_', ' ')}</label>
                                        {inputElement}
                                        {key === 'STATUS' && (
                                                <div className='equipamento-item' style={{ marginTop: '20px' }} >                                                    
                                                    {(
                                                        <div className='miniaturas-container' style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                                                            {photoSlots.map((img) => (
                                                                <div key={img.slot} style={{ textAlign: 'center' }}>
                                                                    <img
                                                                        src={img.image}
                                                                        alt={img.label}
                                                                        style={{ width: 60, height: 60, objectFit: 'cover', borderRadius: 4 }}
                                                                        onClick={() => handleOpenCameraModal(img.slot)}
                                                                    />
                                                                    <p style={{ fontSize: '0.7rem', marginTop: '4px' }}>
                                                                        {img.label}
                                                                    </p>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}

                                                </div>
                                            )}
                                        {key === 'STATUS' && (
                        <div className="driveit-boolean-fields" role="group" aria-label="Opções do equipamento">
                            {BOOLEAN_FIELDS.map(({ key, label }) => (
                                <label className="driveit-boolean-row" key={key} htmlFor={`driveit-${key}`}>
                                    <span>{label}</span>
                                    <input
                                        id={`driveit-${key}`}
                                        name={key}
                                        type="checkbox"
                                        checked={toBoolean(equipamento[key])}
                                        onChange={handleInputChange}
                                    />
                                </label>
                            ))}
                        </div>
                                        )}
                                    </div>

                                );
                            })}

                        </div>
                    </div>

                    <button className='button-editar-perfil-usuario Atos-logo' title="Salvar Alteração" onClick={handleSave}>Salvar</button>
                    <button className='button-editar-perfil-usuario Atos-logo' title="Voltar" onClick={() => navigate('/driveit', { state: { user } })}>Voltar</button>

                </div>
                    <Modal
                    isOpen={isCameraModalOpen}
                    onRequestClose={() => setIsCameraModalOpen(false)}
                    contentLabel="Select Camera"
                    
                    overlayClassName="modal-overlay"
                    style={{
                        content: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        maxHeight: '150vh',
                        margin: 'auto',
                        padding: '20px',                        
                        borderRadius: '8px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                        },
                        overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        }
                    }}
                    >
                    <div className='camera-icons-container' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px' }}>
                        {photoSlots.map((img) => (
                            <div key={img.slot} style={{ textAlign: 'center' }}>
                                <p style={{ marginBottom: '5px', fontWeight: 'bold' }}>
                                    {img.label}
                                </p>
                                <img
                                    src={img.image}
                                    alt={img.label}
                                    style={{ width: 170, height: 170, cursor: 'pointer' }}
                                    onClick={() => {
                                        setSelectedSlot(img.slot);
                                        setShowImageOptions(true);
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                    <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileSelect}
                    />
                    {showImageOptions && (
                        <div className='camera-icons-container' style={{ gap: '10px', marginTop: '10px' }}>
                            <button
                            className='button-editar-perfil-usuario Atos-logo'
                            title="Tirar nova foto"
                            onClick={() => {
                                setShowImageOptions(false);
                                handleOpenWebcamModal(selectedSlot);
                            }}
                            >
                            Tirar nova foto
                            </button>
                            <button
                            className='button-editar-perfil-usuario Atos-logo'
                            title="Excluir foto"
                            onClick={() => {
                                setShowImageOptions(false);
                                handleDeletePhoto(selectedSlot);
                            }}
                            >
                            Excluir
                            </button>
                            <button
                            className="button-editar-perfil-usuario Atos-logo"
                            title="Selecionar do computador"
                            onClick={() => {
                                fileInputRef.current?.click(); 
                                setShowImageOptions(false);
                            }}
                            >
                            Carregar imagem
                            </button>
                        </div>
                        )}


                    <div className='camera-icons-container'>
                        <button
                            className='button-editar-perfil-usuario Atos-logo'
                            title="Voltar"
                            onClick={handleOpenWebcamModalCancel}
                        >
                            Voltar
                        </button>
                    </div>
                </Modal>

            </main>
            <Modal
                    isOpen={isWebcamModalOpen}
                    onRequestClose={() => setIsWebcamModalOpen(false)}
                    contentLabel="Capture Photo"
                    className='camera-icons-container'                     
                    style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px' }}
                    overlayClassName="overlay"                    
                    >
                    <Webcam
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat="image/jpeg"
                        videoConstraints={videoConstraints}
                        style={{ width: 600, height: 500 }}
                    />
                    <div className="button-container">
                        <button className='button-editar-perfil-usuario Atos-logo' title="Tirar foto" onClick={() => handleTakePhoto(selectedCamera)}>Salvar Foto</button>
                        
                        <button className='button-editar-perfil-usuario Atos-logo' title="Cancelar" onClick={handleTakePhotoCancel}>Cancelar</button>
                    </div>
            </Modal>
        </>
    );
}

export default EditarDriveIT;